module.exports = __webpack_public_path__ + "static/media/Christine H Lee.fd2170ae.png";